/* eslint-disable no-param-reassign */
// Arrow function to start a countdown on a specific element
const startCountdown = (endDateTimestamp, nowTimestamp, targetElement) => {
  if (!targetElement || targetElement.getAttribute('data-init')) return;
  const interval = setInterval(() => {
    targetElement.setAttribute('data-init', 'true'); // Set 'data-init' attribute to 'true' to prevent multiple countdowns
    const currentTime = new Date().getTime(); // Get current system time
    const timePassed = currentTime - nowTimestamp; // Calculate how much time has passed since 'now'
    const timeLeft = endDateTimestamp - (nowTimestamp + timePassed); // Calculate remaining time until the end date

    if (timeLeft > 0) {
      // Calculate days, hours, minutes, and seconds left
      const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
      const hours = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);

      // Update the target element with the countdown time
      targetElement.innerHTML = `<span class="hidden sm:block sm:pr-4">Ends in </span>
      ${days}d ${hours}h ${minutes}m <span class="min-w-36 pl-4">${seconds}s</span>`;
    } else {
      // When the countdown ends, update the content and clear the interval
      targetElement.textContent = 'Sale ended';
      // Find the closest parent with the data-flash-sale-wrapper attribute and add 'hidden' class
      const saleWrapper = targetElement.closest('[data-flash-sale-wrapper]');
      if (saleWrapper) {
        saleWrapper.classList.add('hidden');
      }
      clearInterval(interval);
    }
  }, 1000); // Update the countdown every second
};

export default startCountdown;
